export default __webpack_public_path__ + "static/basisDocs-preview-e6211051b0405c9fb09c276aa346df54.jpg";